import DeliveryZone from './DeliveryZone.view';

export default DeliveryZone;
